import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lightTheme, darkTheme } from './constants/colors';
import './styles/global.css';
import Dashboard from '@/pages/dashboard/main/index';
import Timeline from '@/pages/timeline/main/index';
import Profile from '@/pages/profile/main/index';
import Watch from '@/pages/watch/main/index';
import Test from '@/pages/test/index';
import Search from '@/pages/search/index';
import Payment from '@/pages/payment';
import Exam from '@/pages/exam';
import ExamResult from "@/pages/examResult"
import NotificationRoute from "@/pages/notification/NotificationRoute";
import ResourceRoute from "@/pages/resources/ResourceRoute";
import SubscriptionGroupRoute from "@/pages/subscriptionGroup/SubscriptionGroupRoute";
// import Dashboard from './pages/dashboard/Dashboard';
import { RootState } from '@/store';
import { getUserProfileApiCall } from '@/services/api';
import { setCurrentTheme } from '@/store/slices/common/currentThemeSlice';
import { themes } from '@/constants/colors_v2';
import { getSystemTheme } from '@/utils';
import '@/styles/colorsCssVar.css';

// import { setProfile } from '@/store/slices/profile/profileSlice';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);
  const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

  // Apply theme class to body
  // React.useEffect(() => {
  //   document.body.style.backgroundColor = isDarkMode ? darkTheme.background : lightTheme.background;
  //   document.body.style.color = isDarkMode ? darkTheme.text : lightTheme.text;
  // }, [isDarkMode]);


  useEffect(() => {
    getProfileDetails()
  }, [])


  // tetsing
  // useEffect(() => {
  //   console.log(currentTheme)
  // }, [currentTheme])


  // useEffect(()=>{
  //   console.log(profileDetails)
  // },[profileDetails])


  const getProfileDetails = async () => {
    const profileDetails = await getUserProfileApiCall();
    if (profileDetails.data && profileDetails.status) {
      let theme: any = themes.light
      if (profileDetails.data.themePreference === themes.system) {
        theme = getSystemTheme()
      } else if (profileDetails.data.themePreference === themes.light
        || profileDetails.data.themePreference === themes.dark) {
        theme = profileDetails.data.themePreference
      }

      // theme = themes.light // until theme integration is completed
      // theme = themes.dark // testing
      
      dispatch(setCurrentTheme(theme))
      // dispatch(setProfile(profileDetails.data));
    }
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} /> */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/timeline/:id" element={<Timeline />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/test" element={<Test />} />
          <Route path="/search" element={<Search />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/exam" element={<Exam />} />
          <Route path="/exam-result" element={<ExamResult />} />
          <Route path="/notification" element={<NotificationRoute />} />
          <Route path="/notification/:id" element={<NotificationRoute />} />
          <Route path="/resources/:id" element={<ResourceRoute />} />
          <Route path="/subscriptionGroup/:id" element={<SubscriptionGroupRoute />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
